import { render, staticRenderFns } from "./editOrderTime.vue?vue&type=template&id=1bb620a3&scoped=true&"
import script from "./editOrderTime.vue?vue&type=script&lang=js&"
export * from "./editOrderTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb620a3",
  null
  
)

export default component.exports